"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotEye = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotEye = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M19.964 17.097c3.372 2.678 7.728 4.856 12.65 4.57 12.856-.714 5.25-16.191-.808-19.57-3.95-2.2-9.449-2.913-14.027-.95a9.813 9.813 0 0 0-2.307 1.43c-1.821.2-3.657 1.485-3.457 3.463.443 4.321 4.4 8.235 7.95 11.057Z",
    opacity: 0.75
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M1.668 20S8.335 6.667 20.001 6.667C31.668 6.667 38.335 20 38.335 20S31.668 33.334 20 33.334C8.335 33.334 1.668 20 1.668 20Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#13126C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
  }));
};
exports.SpotEye = SpotEye;
SpotEye.displayName = "SpotEye";